import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnSwapStep_13 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_13 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_13) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_12);
    onReset(["timeIntervalTypeCommunication"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_14);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="communication"
        text="Удобное время для связи:"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_13;
